/**
 * @constant {Object} AdminApiUrls
 * @description Contains all admin-related API endpoint URLs used throughout the application.
 */
export const AdminApiUrls = Object.freeze({
  ADMIN_LOGIN: "/user/admin/login/",
  LIST_COMPANIES: "/company/admin/",
  GET_COMPANY: "/company/admin/",
  UPDATE_BID_PRICE: "/payment/admin/amount/",
  GET_PAYMENT_AMOUNT: "/payment/amount/",
  GET_TRANSACTIONS: "/payment/admin/transaction/",
  TRANSACTION_DETAILS: "/payment/admin/transaction/",
  GET_PAYMENTS: "/payment/admin/order/",
  CREATE_BLOG: "/blog/admin/",
  UPDATE_BLOG: "/blog/admin/",
  DELETE_BLOG: "/blog/admin/",
  RETRIEVE_BLOG: "/blog/admin/",
  BLOG_LIST: "/blog/admin/",
  ADMIN_LIST: "/user/admin/team/",
  ADMIN_DETAILS: "/user/admin/team/",
  UPDATE_ADMIN_DETAILS: "/user/admin/team/",
  CREATE_ADMIN: "/user/admin/team/",
  CONTACT_US_QUERY: "/support/admin/contact/",
  RETRIEVE_CONTACT_US_QUERY_DETAIL: "/support/admin/contact/",
  GET_IN_TOUCH_QUERY: "/support/admin/get_in_touch/",
  RETRIEVE_GET_IN_TOUCH_QUERY_DETAIL: "/support/admin/get_in_touch/",
  MISSING_DATA_QUERY: "/support/admin/missing_data_request/",
  RETRIEVE_MISSING_DATA_QUERY_DETAIL: "/support/admin/missing_data_request/",
  CUSTOMER_SUPPORT_QUERY: "/support/admin/ticket/",
  RETRIEVE_CUSTOMER_SUPPORT_QUERY: "/support/admin/ticket/",
  GET_ADMIN_DASHBOARD_DATA: "/dashboard/admin/",
  GET_PORTAL_BIDS: "/bid/admin/",
  FETCH_BID_DETAILS: "/bid/admin/",
  FETCH_COMPANY_REPORT: "/report/admin/company/",
  FETCH_CUSTOMER_REPORT: "/report/admin/customer/",
  FETCH_BIDS_REPORT: "/report/admin/bid/",
  FETCH_PARTICIAPATION_REPORTS: "/report/admin/bid/participant/",
  FETCH_FEEDBACK_REPORT: "/report/admin/feedback/",
  FETCH_TRANSACTION_REPORT: "/report/admin/transaction/",
  CLOSE_CONTACT_QUERY: "/support/admin/contact/",
  CLOSE_BOOK_A_DEMO_QUERY: "/support/admin/get_in_touch/",
  CLOSE_SUPPORT_QUERY: "/support/admin/ticket/",
  CLOSE_MISSING_DATA_QUERY_QUERY: "/support/admin/missing_data_request/",
  BRODCASTING_NOTFICATION: "/notification/admin/broadcast/",
});
